<template>
	<div class="moonSampleInfoClass">
		<el-page-header @back="goBack" class="backClass" content="详情页面"> </el-page-header>
		<div class="titleNameClass">{{ sampleData.borrowCode ? sampleData.borrowCode : sampleData.orderNo }}</div>
		<div class="contentDivClass">
			<div class="spanInforDivClass">
				<div class="titleDivClass">
					<span class="titleSpanNameClass">基本信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<!-- <div class="dataInforDivClass">
						<span class="nameClass">借用样品id</span>
						<span class="valueClass">{{ sampleData.sampleDataId }}</span>
					</div> -->
					<!-- <div class="dataInforDivClass">
						<span class="nameClass">订单编号</span>
						<span class="valueClass" v-html="sampleData.orderNo"></span>
					</div> -->
					<div class="dataInforDivClass">
						<span class="nameClass">使用方式</span>
						<span class="valueClass" v-if="sampleData.useType == 1">原样使用</span>
						<span class="valueClass" v-else-if="sampleData.useType == 2">消耗性使用</span>
						<span class="valueClass" v-else-if="sampleData.useType == 3">破坏性使用</span>
						<span class="valueClass" v-else-if="sampleData.useType == 4">展览</span>
						<span class="valueClass" v-else-if="sampleData.useType == 5">教育</span>
						<span class="valueClass" v-else-if="sampleData.useType == 6">科普</span>
						<span class="valueClass" v-else-if="sampleData.useType == 7">其他</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">预计返还时间</span>
						<span class="valueClass">{{ sampleData.expectedReturnTime == null ? '暂无数据' : sampleData.expectedReturnTime }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">实际返还时间</span>
						<span class="valueClass">{{ sampleData.actualReturnTime == null ? '暂无数据' : sampleData.actualReturnTime }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品借用质量</span>
						<span class="valueClass">{{ sampleData.borrowWeight == null ? '暂无数据' : sampleData.borrowWeight + 'mg' }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">样品返还质量</span>
						<span class="valueClass">{{ sampleData.returnWeight == null ? '暂无数据' : sampleData.returnWeight + 'mg' }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">预期消耗量</span>
						<span class="valueClass">{{ sampleData.expectedConsumption == null ? '暂无数据' : sampleData.expectedConsumption + 'mg' }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">实际消耗量</span>
						<span class="valueClass">{{ sampleData.actualConsumption == null ? '暂无数据' : sampleData.actualConsumption + 'mg' }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">开始使用时间</span>
						<span class="valueClass">{{ sampleData.useStartTime == null ? '暂无数据' : sampleData.useStartTime }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">结束使用时间</span>
						<span class="valueClass">{{ sampleData.useEndTime == null ? '暂无数据' : sampleData.useEndTime }}</span>
					</div>
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">使用单位信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">单位名称</span>
						<span class="valueClass">{{ sampleData.companyName }}</span>
					</div>
					<!-- <div class="dataInforDivClass">
						<span class="nameClass">单位法人</span>
						<span class="valueClass">{{ sampleData.legalPerson }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">法人身份证号</span>
						<span class="valueClass">{{ sampleData.legalPersonId }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">法人联系电话</span>
						<span class="valueClass">{{ sampleData.legalPersonTel == null ? '暂无数据' : sampleData.legalPersonTel }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">法人电子邮箱</span>
						<span class="valueClass">{{ sampleData.legalPersonEmail == null ? '暂无数据' : sampleData.legalPersonEmail }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">法人联系电话</span>
						<span class="valueClass">{{ sampleData.legalPersonTel == null ? '暂无数据' : sampleData.legalPersonTel }}</span>
					</div> -->
				</div>

				<div class="titleDivClass">
					<span class="titleSpanNameClass">使用人信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">使用责任人</span>
						<span class="valueClass">{{ sampleData.usePerson == null ? '暂无数据' : sampleData.usePerson }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">责任人身份证号</span>
						<span class="valueClass">{{ sampleData.usePersonId == null ? '暂无数据' : sampleData.usePersonId }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">责任人联系电话</span>
						<span class="valueClass">{{ sampleData.usePersonTel == null ? '暂无数据' : sampleData.usePersonTel }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">责任人电子邮箱</span>
						<span class="valueClass" v-html="sampleData.usePersonEmail"></span>
					</div>
				</div>
				<div class="titleDivClass">
					<span class="titleSpanNameClass">借用信息</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="nameClass">借用审核员</span>
						<span class="valueClass">{{ sampleData.borrowReview }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">借用审核时间</span>
						<span class="valueClass">{{ sampleData.borrowReviewTime }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">返还审核员</span>
						<span class="valueClass">{{ sampleData.returnReview }}</span>
					</div>
					<div class="dataInforDivClass">
						<span class="nameClass">返还审核时间</span>
						<span class="valueClass">{{ sampleData.returnReviewTime }}</span>
					</div>
				</div>
				<div class="titleDivClass">
					<span class="titleSpanNameClass">借用审核失败原因</span>
					<span class="lineRightClass"></span>
				</div>
				<div class="spanInforClass">
					<div class="dataInforDivClass">
						<span class="valueClass">{{ sampleData.borrowReviewReason }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			options: [
				{
					value: '1',
					label: '原样使用'
				},
				{
					value: '2',
					label: '消耗性使用'
				},
				{
					value: '3',
					label: '破坏性使用'
				},
				{
					value: '4',
					label: '展览'
				},
				{
					value: '5',
					label: '教育'
				},
				{
					value: '6',
					label: '科普'
				},
				{
					value: '7',
					label: '其他'
				}
			],
			sampleData: '',
			sampleBorrwingTable: []
		}
	},
	methods: {
		goBack() {
			this.$emit('goBackFunc', 1)
		},
		async initDataFunc(row) {
			console.log(row)
			this.sampleData = row
			// const params = {
			// 	pageSize: 1000,
			// 	pageNum: 1,
			// 	orderNo: row.code
			// }
			// let res = await this.$http.get(this.$const.moonSample.getMoonSampleBorrowingReturn, params);
			// if (res && res.code==200) {
			// 	this.sampleBorrwingTable = res.rows
			// }
		}
	}
}
</script>

<style lang="scss" scoped>
.moonSampleInfoClass {
	width: 1200px;
	text-align: center;
	display: inline-block;
	.backClass {
		height: 40px;
		width: 100%;
		background: linear-gradient(90deg, rgba(251, 251, 251, 0.5) 0%, #f8f8f8 49%, rgba(245, 245, 245, 0.5) 100%);
		line-height: 40px;
	}
	.titleNameClass {
		height: 80px;
		font-family: MicrosoftYaHeiUISemibold;
		font-size: 28px;
		color: #000000;
		line-height: 80px;
		text-align: left;
		font-style: normal;
	}
	.contentDivClass {
		width: 1200px;
		// height: 1196px;
		background: #ffffff;
		border-radius: 4px;
		padding: 24px;
		border: 1px solid rgba(21, 65, 140, 0.2);
		.spanInforDivClass,
		.sampleBorrowingClass {
			display: flex;
			flex-direction: column;
			justify-content: left;
			.titleDivClass {
				display: flex;
				justify-content: left;
				align-items: center;
				height: 60px;
				.titleSpanNameClass {
					// width: 108px;
					height: 19px;
					font-family: ReeJi-BigRuixain, ReeJi-BigRuixain;
					font-weight: normal;
					font-size: 18px;
					color: #15418c;
					line-height: 19px;
					text-align: left;
					font-style: normal;
					font-weight: 600;
				}
				.lineRightClass {
					width: 84%;
					// border-image: linear-gradient(270deg, rgba(21, 65, 140, 0.1), rgba(21, 65, 140, 0.3)) 1 1;
					border-style: dashed;
					border-width: 1px;
					border-color: #abc0e3;
				}
			}
			.spanInforClass {
				display: flex;
				align-items: center;
				justify-content: left;
				width: 1100px;
				min-height: 60px;
				flex-wrap: wrap;
				.dataInforDivClass {
					display: flex;
					justify-content: left;
					align-items: baseline;
					width: 49%;
					.nameClass {
						width: 120px;
						height: 40px;
						display: flex;
						margin-bottom: 15px;
						align-items: center;
						justify-content: center;
						background: rgba(21, 65, 140, 0.08);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.valueClass {
						// height: 21px;
						// width: 150px;
						font-family: MicrosoftYaHeiUISemibold;
						font-size: 16px;
						color: #15418c;
						line-height: 21px;
						text-align: left;
						font-style: normal;
						word-break: break-all;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: normal;
					}
				}
			}
			.imgSampleClass {
				display: flex;
				justify-content: center;
				align-items: center;
				.imgInforClass {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;
					span {
						width: auto;
						height: 32px;
						background: #15418c;
						border-radius: 16px;
						opacity: 0.5;
						color: #fff;

						padding-right: 15px;
						padding-left: 15px;
						margin-top: 24px;
						line-height: 32px;
						font-size: 14px;
					}
				}
			}
		}
	}
}
</style>>